<ul>
    <div class="alarm-row text" [ngClass]="getNgClass()">
        <li class="td text-overflow-cutoff">
            {{ alarm.channel }}
        </li>
        <li class="td text-overflow-cutoff">
            {{ alarm.name | uppercase }}
        </li>
        <li class="td td-status text-overflow-cutoff">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <span class="text-overflow-cutoff">{{
                alarm.status | uppercase
            }}</span>
        </li>
        <li class="td text-overflow-cutoff">
            {{ alarm.value }}
        </li>
        <li class="td td-btn">
            <button (click)="emitShowDetail()" class="border">
                {{ "alarm.button.details" | translate | uppercase }}
            </button>
            <button
                (click)="emitAck()"
                class="primary"
                [disabled]="disableAckButton"
            >
                {{ "alarm.button.ack" | translate | uppercase }}
            </button>
        </li>
    </div>
</ul>
